import { DateField, TextField } from '@mi-front/ui';
import moment from 'moment-timezone';
import { useIntl } from 'react-intl';
import { useTimezone } from '../../../../../../core/hooks';

export function BcrMatchesReportForm(p: any) {
  const { $t } = useIntl();
  const tz = useTimezone();

  return (
    <div className="row">
      <div className="col-4">
        <DateField
          name="date"
          label={$t({
            id: 'audit.reportsScreen.bcrMatches.date',
            defaultMessage: 'Fecha',
          })}
          isOutsideRange={(date) => moment(date) > moment()}
        />
      </div>
      <div className="col-4">
        <TextField
          name="customId"
          label={$t({
            id: 'audit.reportsScreen.bcrMatches.customId',
            defaultMessage: 'Custom ID (opcional)',
          })}
        />
      </div>
    </div>
  );
}
